let faq = {
	init: function(){
		faq.nav();
	},
	nav: function(){
		$(".nav_faq li a").off().on("click", function(){
			let idx = $(".nav_faq li a").index(this);
			let posY = $(".block_faq").eq(idx).offset().top;
			let headerH = $(".ttl_h1").offset().top + $(".ttl_h1").outerHeight();
			posY = posY - headerH;
			common.scrollToPosByNum(posY);
		});
		$(".list_faq li a").off().on("click", function(){
			let idx = $(".list_faq li a").index(this);
			faq.toggleBlock(idx);
		});
	},
	toggleBlock: function(idx){
		let $block = $(".list_faq li").eq(idx);
		if( !$block.hasClass("open") ){
			$block.addClass("open");
		}else{
			$block.removeClass("open");
		}
		$block.find(".answer").animate({
			height: "toggle", opacity: "toggle"
		},{
			duration: 300,
			complete: function(){
				common.resize();
			}
		});
	}
}